import type { Transaction } from '@api/hooks/types/getTransactions';
import { useTransactions } from '@api/hooks/useTransactions';
import { Skeleton } from '@components/skeleton/Skeleton';
import { useBankProfile } from '@contexts/BankProfileContext';
import { CardItem, ChevronLeftIcon, SignIcon, Typography } from '@gurupay/gp-ui-library';
import { formatNumberAmount } from '@utils/utils';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export const CreatedTransactions = () => {
	const { t } = useTranslation();
	const { selectedProfile } = useBankProfile();
	const { data, isLoading, isError } = useTransactions(
		selectedProfile?.id,
		1,
		3,
		undefined,
		undefined,
		undefined,
		undefined,
		['created'],
	);
	const payments: Transaction[] = data?.items ?? [];

	if (!isLoading && (isError || !payments.length)) {
		return null;
	}

	return (
		<div className="space-y-4">
			<Typography className="flex flex-row gap-space-12" level="h3">
				{t('paymentsPage.signPayments')}
				{!isLoading && (
					<Link to="/operations?status=created">
						<ChevronLeftIcon className="rotate-180 text-brand-secondary-700" />
					</Link>
				)}
			</Typography>
			{isLoading ? (
				<div className="flex flex-row overflow-x-auto lg:overflow-visible gap-space-16">
					<Skeleton className="h-[100px] w-[calc(100%/3-11px)] min-w-[250px]" />
					<Skeleton className="h-[100px] w-[calc(100%/3-11px)] min-w-[250px]" />
					<Skeleton className="h-[100px] w-[calc(100%/3-11px)] min-w-[250px]" />
				</div>
			) : (
				<ul className="flex flex-row overflow-x-auto lg:overflow-visible gap-space-16">
					{payments.map((p) => (
						<CardItem
							key={p.id}
							icon={<SignIcon />}
							iconClassName="text-brand-primary-800 !bg-brand-primary-50"
							linkClassName="border border-neutral-100 rounded-md px-space-16 w-[calc(100%/3-11px)] min-w-[250px]"
							subTitle={`${formatNumberAmount(p.amount.toFixed(2))} ${p.currency}`}
							title={p.beneficiary.name}
							to={`/payments/${p.id}`}
						>
							{p.payment_details}
						</CardItem>
					))}
				</ul>
			)}
		</div>
	);
};
